import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import IncomingCallNotification from '../components/IncomingCallNotification';
import Sidebar from '../components/Sidebar';
import TaroBot from '../components/TaroBot';
import { NotificationProvider } from '../contexts/NotificationContext';
import { auth } from '../firebase';
import { dietitianApi } from '../services/dietitianApi';
import { colors } from '../theme';

const DietitianLayout: React.FC = () => {
  const location = useLocation();
  const [currentUser, setCurrentUser] = useState(auth.currentUser);
  const [dietitianId, setDietitianId] = useState<string | undefined>(undefined);
  const [sidebarWidth, setSidebarWidth] = useState(280);

  // Auth state değişikliğini dinle
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
    });
    return () => unsubscribe();
  }, []);

  // Dietitian ID'yi yükle
  useEffect(() => {
    const loadDietitianId = async () => {
      if (currentUser?.email) {
        try {
          const dietitian = await dietitianApi.getDietitianByEmail(
            currentUser.email
          );
          setDietitianId(dietitian.id);
        } catch (error) {
          console.error('Dietitian ID yüklenemedi:', error);
        }
      }
    };

    loadDietitianId();
  }, [currentUser]);

  // Route'dan activeTab'i belirle
  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes('/clients')) return 'clients';
    if (path.includes('/appointments')) return 'appointments';
    if (path.includes('/programs')) return 'programs';
    if (path.includes('/automated-messages')) return 'automated-messages';
    if (path.includes('/messages')) return 'messages';
    if (path.includes('/client-requests')) return 'client-requests';
    if (path.includes('/content')) return 'content';
    if (path.includes('/settings')) return 'settings';
    return 'dashboard';
  };

  return (
    <NotificationProvider currentUserId={dietitianId} userRole="dietitian">
      <Box
        sx={{
          display: 'flex',
          minHeight: '100vh',
          bgcolor: colors.background.main,
          width: '100%',
          maxWidth: '100vw',
          overflowX: 'hidden',
        }}
      >
        <Sidebar
          userRole="dietitian"
          activeTab={getActiveTab()}
          onTabChange={() => { }} // Artık navigation Sidebar içinde navigate ile yapılacak
          onWidthChange={setSidebarWidth}
        />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            px: 1.5,
            pt: 1,
            ml: { xs: 0, md: `${sidebarWidth}px` },
            mt: { xs: 0, md: 0 },
            transition: 'margin-left 0.3s ease',
            width: '100%',
            maxWidth: '100vw',
            overflowX: 'auto',
            overflowY: 'hidden',
          }}
        >
          <Outlet />
        </Box>

        {/* Global Gelen Arama Bildirimi */}
        {dietitianId && (
          <IncomingCallNotification
            currentUserId={dietitianId}
            isDietitian={true}
          />
        )}

        {/* Taro Bot - Mesajlaşma sayfasında gizle */}
        {dietitianId && !location.pathname.includes('/messages') && (
          <TaroBot dietitianId={dietitianId} isDietitian={true} />
        )}
      </Box>
    </NotificationProvider>
  );
};

export default DietitianLayout;
